export class NotificationSubscription{
    public ID: number;
    public EventConfigID: number;
    public EventConfigCode: string;
    public EventConfigName: string;
    public EventConfigMode: string;
    public LoginName: string;
    public Selected: boolean = false
}